export default __webpack_public_path__ + "static/use-1-es-e78cf6f6263a0132f90c9828355e1a11.png";